// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"64bb2375","554":"7f2f7a26","671":"70035597","787":"62a7c071"}[chunkId] + ".chunk.js";
};